module.exports = __webpack_public_path__ + "img/xls.904d4e71.svg";